import ReactTyped from "react-typed";
import { Link } from "react-router-dom";

function Hero() {
  return (
    <div className="my-40 g-cover mbg-center md:my-48">
      <div className="px-2 max-w-[600px] w-full mx-auto text-center flex flex-col justify-center">
        <div>
            <div>
              <h1 className="font-bold text-[30px] md:text-[32px] lg:text-[36px] text-transparent bg-clip-text bg-gradient-to-l from-adhocDonkerBlauw to-adhocBlauw">
                Ad Hoc IT Services
              </h1>
              <div className="flex justify-center gap-2 mb-4">
                <p className="font-semibold text-[20px] md:text-[24px] lg:text-[26px]">
                  Op zoek naar
                </p>
                <ReactTyped
                  className="font-bold text-[20px] md:text-[24px] lg:text-[26px] text-adhocBlauw "
                  strings={[
                    "Systeembeheerders?",
                    "Web developers?",
                    "Cybersecurity advies?",
                    "Werkplekbeheerders?",
                    "App developers?",
                  ]}
                  typeSpeed={60}
                  backSpeed={40}
                  loop
                />
              </div>
              <p className="max-w-xs mx-auto md:max-w-none font-semibold text-slate-600 text-[16px] md:text-[18px] lg:text-[20px] leading-8">
                Uw betrouwbare partner voor ICT en Cybersecurity.
              </p>
              <Link to="/offerte">
                <button className="px-8 py-2 mt-8 text-[18px] md:text-[20px] font-semibold text-white rounded-[100px] max-w-fit mx-auto bg-gradient-to-br from-adhocBlauw  via-adhocBlauw200  to-adhocDonkerBlauw bg-size-200 bg-pos-0 hover:bg-pos-100 transition-all duration-300">
                  Offerte Aanvragen
                </button>
              </Link>
            </div>
        </div>
      </div>
    </div>
  );
}

export default Hero;
